import * as _ from 'lodash';
import nextEntityNameGenerator from './nextEntityNameGenerator';
import { IScript } from '../../models/IScript';

export function nextDuplicatedScriptName(scriptName: string, scripts: IScript[]) {
    const possibleName = nextEntityNameGenerator(scriptName, '_');

    if (_.find(scripts, { name: possibleName })) {
        return nextDuplicatedScriptName(possibleName, scripts)
    }
    return possibleName;
}